import Logger from './logger';

const close = (reason, args, callback = window.WC.Closer._onCloseCallback) => {
    Logger.log(
        'close reason ->',
        reason,
        ', args=',
        JSON.stringify({
            ...args,
            callback: callback
        })
    );

    if (callback && !window.WC.Closer._authorizationFailed) {
        if (
            args?.verMO &&
            args?.contactProcessType &&
            ['Support', 'Sale'].some((cpt) => args.contactProcessType === cpt)
        ) {
            // window.closer.log({
            //     message: 'deinit:before callback'
            // });
            window.closer.deinit();
        }
        callback('onNativeClose');
    } else {
        window.WC.Closer._authorizationFailed = false;
        // window.closer.log({
        //     message: 'deinit'
        // });
        // window.closer.deinit();
    }

    if (
        !reason &&
        !args &&
        window.WC?.Closer?._processTypeData?.additionalData['wersja aplikacji MO']
    ) {
        window.closer.deinit();
    }
};

export default close;
